<template>
<div class="mb-3 col-6 col-sm-3 col-md-2 item" :class="{'list-group-item': displayList}">
  <div class="thumbnail card">
    <div class="img-event intrinsic">
      <img :src="item.picUrl" alt="" class="grow thumbnail-image card-img-top intrinsic-item p-2">
    </div>
    <div class="card-body p-2">
      <button class="btn btn-success btn-sm w-100 text-truncate" @click="showProducts(item.name)" :title="item.name">
        {{ item.name }} 
      </button>
    </div>
  </div>
</div>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  props: ['item', 'displayList'],

  methods: {
    ...mapActions(['getItem2List']),

    showProducts(item1Name) {
      this.getItem2List({item1Name})
    }
  },

  filters: {
    shortDescription(value) {
      if (value && value.length > 100) {
        return value.substring(0, 100) + '...';
      } else {
        return value;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
div.card {
  height: 100%;
}

.btn-sm {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.3rem 0.4rem;
}

.card-title {
  font-size: 0.9rem;
  font-weight: bold;
}

.card-text {
  font-size: 0.875rem;
}

.remain {
  color: #d17581;
}

.grow {
  transition: all .2s ease-in-out;
}

.grow:hover {
  transform: scale(1.1);
}

.list-group-item {
  float: none;
  width: 100%;
  background-color: #fff;
  margin-bottom: 30px;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 1rem;
  border: 0;
  .thumbnail {
    display: inline-block;
    width: 100%;
  }
  .img-event {
    width: 20%;
    float: left;
    padding: 0 !important;
    margin: 0;
    height: auto;
  }

  .thumbnail-image {
    position: static;
  }

  .card-body {
    float: left;
    width: 80%;
    margin: 0;
  }

  @media (max-width: 767.98px) {
    .img-event {
      width: 30%;
      float: left;
      padding: 0 !important;
      margin: 0;
    }

    .card-body {
      float: left;
      width: 70%;
      margin: 0;
    }
  }
}




.item.list-group-item:before, .item.list-group-item:after
{
    display: table;
    content: " ";
}

.item.list-group-item:after {
  clear: both;
}
</style>
